// Settings.jsx
import React from "react";
import styled from "styled-components";

const Card = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  text-align: center;
`;

const Heading = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

const Subtext = styled.p`
  font-size: 0.95rem;
  color: #555;
`;

export default function Settings() {
  return (
    <Card>
      <Heading>Settings</Heading>
      <Subtext>Update your preferences and configurations. --COMING SOON</Subtext>
    </Card>
  );
}